import { render, staticRenderFns } from "./albums.vue?vue&type=template&id=33693cfc&scoped=true"
import script from "./albums.vue?vue&type=script&lang=ts"
export * from "./albums.vue?vue&type=script&lang=ts"
import style0 from "./albums.vue?vue&type=style&index=0&id=33693cfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33693cfc",
  null
  
)

export default component.exports